var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "buyProduct-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.list.length > 0
      ? _c(
          "div",
          { staticClass: "product-list" },
          _vm._l(_vm.list, function(item, index) {
            return _c("div", { key: index }, [
              _c("div", { staticClass: "flex product-list-header" }, [
                _c("div", { staticClass: "flex center" }, [
                  _c("img", {
                    staticClass: "camera",
                    attrs: { src: require("@/assets/img/camera.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "product-name" }, [
                    _vm._v("服务单类型：" + _vm._s(item.U_ServiceTktType || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "product-list-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "basic-information-flex",
                    class: item.edit == true ? "active" : "activeno"
                  },
                  [
                    _c("ul", { staticClass: "basic-information-lists" }, [
                      _c("li", [
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-item" },
                          [_vm._v("维修日期")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-text" },
                          [_vm._v(_vm._s(item.U_RealCompletDate || ""))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-item" },
                          [_vm._v("产品货号")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-text" },
                          [_vm._v(_vm._s(item.U_Code || ""))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-item" },
                          [_vm._v("产品大类")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-text" },
                          [_vm._v(_vm._s(item.U_ProductType || ""))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-item" },
                          [_vm._v("产品分类")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-text" },
                          [_vm._v(_vm._s(item.U_LeicaProductType || ""))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-item" },
                          [_vm._v("产品名称")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-text" },
                          [_vm._v(_vm._s(item.U_ProductNameCN || ""))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-item" },
                          [_vm._v("产品英文名")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-text" },
                          [_vm._v(_vm._s(item.U_ProductNameEN || ""))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-item" },
                          [_vm._v("序列号")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-text" },
                          [_vm._v(_vm._s(item.U_Serial || ""))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-item" },
                          [_vm._v("报修内容")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-text" },
                          [_vm._v(_vm._s(item.U_RepairContent || ""))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-item" },
                          [_vm._v("检测结果")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-text" },
                          [_vm._v(_vm._s(item.U_CheckResult || ""))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-item" },
                          [_vm._v("服务状态")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "basic-information-lists-text" },
                          [_vm._v(_vm._s(item.stateName || ""))]
                        )
                      ])
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex packUp center",
                  on: {
                    click: function($event) {
                      return _vm.packUp(index)
                    }
                  }
                },
                [
                  item.edit == true
                    ? _c("img", {
                        staticClass: "arrow",
                        attrs: {
                          src: require("@/assets/img/upArrow1.png"),
                          alt: "",
                          srcset: ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.edit == false
                    ? _c("img", {
                        staticClass: "arrow",
                        attrs: {
                          src: require("@/assets/img/dowmArrow.png"),
                          alt: "",
                          srcset: ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(
                    "\n        " +
                      _vm._s(item.edit == true ? "收起详情" : "展开详情") +
                      "\n      "
                  )
                ]
              )
            ])
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "buyProduct" }, [
      _c("div", { staticClass: "basic-information-title" }, [
        _vm._v("维修记录")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b1dddc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b1dddc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/repairHis.vue
// module id = null
// module chunks = 